module.exports = __webpack_public_path__ + "static/media/hr.f3343a85.jpg";